import personaService from '@/servicios/persona'
import { ERROR_OBTENER_DATOS_PERSONA } from '@/utilidades/errores'

export const GuardaFirmaAutografaDigitalMixin = {
  data: () => ({
    consumiendoPersona: true,
  }),
  methods: {
    // Metodos publicos
    GuardaFirmaAutografaDigital(request) {
      this.$_GuardaFirmaAutografaDigitalMixin_IniciaGuardaFirmaAutografaDigital()
      personaService
        .guardarFirmaAutografaDigital(request)
        .then((result) => {
          console.log(result)

          this.$_GuardaFirmaAutografaDigitalMixin_TerminaGuardaFirmaAutografaDigital()
          if (result.status != 200) {
            this.errorGuardaFirmaAutografaDigital(ERROR_OBTENER_DATOS_PERSONA)
            return
          }
        })
        .catch((err) => {
          this.$_GuardaFirmaAutografaDigitalMixin_TerminaGuardaFirmaAutografaDigital()
          console.error(err)
          this.errorGuardaFirmaAutografaDigital(ERROR_OBTENER_DATOS_PERSONA)
        })
    },
    postGuardaFirmaAutografaDigital() {},
    errorGuardaFirmaAutografaDigital(mensaje) {
      console.error(mensaje)
    },

    // Metodos privados
    $_GuardaFirmaAutografaDigitalMixin_IniciaGuardaFirmaAutografaDigital() {
      this.consumiendoPersona = true
    },
    $_GuardaFirmaAutografaDigitalMixin_TerminaGuardaFirmaAutografaDigital() {
      this.consumiendoPersona = false
    },
  },
}
